import { Component } from '@angular/core';

/**
 * Sticky action bar for edit screens. Placed as the LAST element of a routed
 * edit component (a direct child of the scrolling `.canvas`), it stays pinned to
 * the bottom of the content area so Save/Cancel are always reachable on long
 * forms. It bleeds over the canvas padding so it sits flush to the very bottom
 * with nothing visible beneath it. Project the action buttons as content:
 *
 *   <app-form-footer>
 *     <app-button buttonType="ghost" text="Odustani" (click)="cancel()"></app-button>
 *     <app-button text="Spremi" (click)="save()"></app-button>
 *   </app-form-footer>
 */
@Component({
  selector: 'app-form-footer',
  templateUrl: './form-footer.component.html',
  styleUrls: ['./form-footer.component.scss'],
})
export class FormFooterComponent {}
